export var ExerciseUploadWsType;
(function (ExerciseUploadWsType) {
    ExerciseUploadWsType["WAIT"] = "WAIT";
    ExerciseUploadWsType["CONNECT"] = "CONNECT";
    ExerciseUploadWsType["UPLOADED"] = "UPLOADED";
    ExerciseUploadWsType["DELETED"] = "DELETED";
    ExerciseUploadWsType["FINISHED"] = "FINISHED";
})(ExerciseUploadWsType || (ExerciseUploadWsType = {}));
//# sourceMappingURL=exercise-upload-ws-type.js.map